<section class="flex flex-col font-display">
  <span class="text-2xl sm:text-3xl font-bold">Position</span>
  <div class="flex flex-col gap-4 w-full sm:w-1/2 lg:w-1/3">
    <div class="flex flex-wrap items-center gap-3 mt-6">
      <button
        (click)="addPosition()"
        class="w-full sm:w-auto min-w-52 h-12 rounded-lg bg-[#42A5CE] text-white flex items-center justify-center space-x-2"
      >
        <i class="fa-solid fa-plus"></i>
        <span>Add New</span>
      </button>
    </div>
    <div class="relative">
      <input
        type="text"
        class="w-full h-12 border border-gray-200 rounded-lg p-4 pl-11 text-[#5C5C5C] text-sm focus:outline-none"
        placeholder="Cari..."
        [formControl]="searchFormControl"
      />
      <i class="fa-solid fa-magnifying-glass absolute left-4 top-4"></i>
    </div>
  </div>
  <div class="overflow-x-auto">
    <table
      mat-table
      [dataSource]="dataSource"
      class="mat-elevation-z0 mt-6 font-display min-w-max w-full"
    >
      <ng-container matColumnDef="no">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold text-base sm:text-lg whitespace-nowrap">No.</th>
        <td mat-cell *matCellDef="let element; let i = index">
          {{ parseNo(i) || '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold text-base sm:text-lg whitespace-nowrap">Name</th>
        <td mat-cell *matCellDef="let element">{{ element.name || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="code">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold text-base sm:text-lg whitespace-nowrap">Code</th>
        <td mat-cell *matCellDef="let element">
          <span class="inline-flex items-center rounded-md bg-slate-100 px-2 py-1 text-xs font-semibold text-slate-900">
            {{ element.code || '-' }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="reportScope">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold text-base sm:text-lg whitespace-nowrap">Report Scope</th>
        <td mat-cell *matCellDef="let element">
          {{ element.reportScope || '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold text-base sm:text-lg whitespace-nowrap">Description</th>
        <td mat-cell *matCellDef="let element">{{ element.description || '-' }}</td>
      </ng-container>

      <ng-container matColumnDef="created_at">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold text-base sm:text-lg whitespace-nowrap">Created Date</th>
        <td mat-cell *matCellDef="let element">
          {{ element.created_at ? (element.created_at | date : 'fullDate' : '+0700') : '-' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="updated_at">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold text-base sm:text-lg whitespace-nowrap">Modified Date</th>
        <td mat-cell *matCellDef="let element">
          {{ element.updated_at ? (element.updated_at | date : 'fullDate' : '+0700') : '-' }}
        </td>
      </ng-container>

      <ng-container stickyEnd matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef class="!font-semibold text-base sm:text-lg whitespace-nowrap">Action</th>
        <td mat-cell *matCellDef="let element">
          <button
            type="button"
            [matMenuTriggerFor]="menu"
            class="inline-flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 text-slate-600 hover:border-slate-300 hover:text-slate-900"
          >
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </button>

          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="editPosition(element.id)">
              <span class="font-display text-sm">
                <i class="fa-solid fa-pen-to-square mr-3"></i>Edit
              </span>
            </button>
            <button mat-menu-item (click)="remove(element)">
              <span class="font-display text-sm">
                <i class="fa-solid fa-trash mr-3"></i>Hapus
              </span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          <div class="w-full flex flex-col items-center justify-center gap-2 py-6 text-center font-display">
            <div class="flex h-10 w-10 items-center justify-center rounded-full bg-slate-100 text-slate-400">
              <i class="fa-solid fa-inbox"></i>
            </div>
            <span class="text-sm font-semibold text-slate-700">No data available</span>
            <span class="text-xs text-slate-500">Try adjusting filters or search.</span>
          </div>
        </td>
      </tr>
    </table>
  </div>
  <mat-paginator
    [length]="dataTotal"
    [pageSize]="limit"
    [pageSizeOptions]="pageSizeOption"
    (page)="onPageChange($event)"
    aria-label="Select page"
  >
  </mat-paginator>
</section>
